"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const bifrost_number_1 = require("@bifrost-platform/bifrost-number");
const constant_1 = require("./constant");
;
class BifiTokenList {
    constructor(tokenList, callListner) {
        this.tokenList = [];
        this.callListener = callListner;
        let usd = this.getDefaultToken('usd');
        usd.unit = '$';
        usd.replaceString = '$ {}';
        this.tokenList.push(usd);
        if (tokenList instanceof Array) {
            for (const token of tokenList) {
                this.setToken(token.key, token.price, token.decimals, token.address, token.title, token.symbol, token.unit, token.replaceString, token.image, token.color);
            }
        }
    }
    getTokenList() {
        return this.tokenList;
    }
    getTokenIndex(key) {
        return this.tokenList.findIndex((token) => token.key === key);
    }
    getToken(key) {
        return this.tokenList.find(token => token.key === key) || this.getDefaultToken(key);
    }
    hasToken(key) {
        return this.getTokenIndex(key) !== -1;
    }
    getDefaultToken(key) {
        const temporaryTitle = `${key}`.toUpperCase();
        const temporarySymbol = temporaryTitle.slice(0, 4);
        return {
            key: key,
            price: new bifrost_number_1.default('1'),
            decimals: constant_1.DEFAULT_DECIMALS,
            address: '',
            title: temporaryTitle,
            symbol: temporarySymbol,
            image: '',
            color: '#efefef',
            unit: temporaryTitle,
            replaceString: `{} ${temporaryTitle}`
        };
    }
    setToken(key, price, decimals, address, title, symbol, unit, replaceString, image, color) {
        if (!key) {
            return;
        }
        let isChange = false;
        const tokenIndex = this.getTokenIndex(key);
        if (tokenIndex > -1) {
            const token = this.tokenList[tokenIndex];
            const newToken = {
                price: new bifrost_number_1.default(price || token.price),
                decimals: new bifrost_number_1.default(decimals || token.decimals),
                title: title || token.title,
                symbol: symbol || token.symbol,
                image: image || token.image,
                color: color || token.color,
                unit: unit || token.unit,
                replaceString: replaceString || token.replaceString
            };
            if (!token.price.eq(newToken.price)
                || !token.decimals.eq(newToken.decimals)
                || token.title !== newToken.title
                || token.symbol !== newToken.symbol
                || token.image !== newToken.image
                || token.color !== newToken.color
                || token.unit !== newToken.unit
                || token.replaceString !== newToken.replaceString) {
                isChange = true;
            }
            token.price = newToken.price;
            token.decimals = newToken.decimals;
            token.title = newToken.title;
            token.symbol = newToken.symbol;
            token.image = newToken.image;
            token.color = newToken.color;
            token.unit = newToken.unit;
            token.replaceString = newToken.replaceString;
        }
        else {
            const temporaryTitle = `${key}`.toUpperCase();
            const temporarySymbol = temporaryTitle.slice(0, 4);
            this.tokenList.push({
                key: key,
                price: new bifrost_number_1.default(price || '1'),
                decimals: new bifrost_number_1.default(decimals || constant_1.DEFAULT_DECIMALS),
                address: address || temporaryTitle,
                title: title || temporaryTitle,
                symbol: symbol || temporarySymbol,
                image: image || '',
                color: color || '#efefef',
                unit: unit || temporaryTitle,
                replaceString: replaceString || `{} ${temporaryTitle}`
            });
            isChange = true;
        }
        if (isChange) {
            this.callListener('tokenList');
        }
    }
    setTokenPrice(key, price) {
        if (!key) {
            return;
        }
        let isChange = false;
        const tokenIndex = this.getTokenIndex(key);
        if (tokenIndex > -1) {
            const token = this.tokenList[tokenIndex];
            const newPrice = new bifrost_number_1.default(price || token.price);
            if (!token.price.eq(newPrice)) {
                isChange = true;
            }
            token.price = newPrice;
        }
        else {
            this.tokenList.push(Object.assign({}, this.getDefaultToken(key), {
                price: new bifrost_number_1.default(price)
            }));
            isChange = true;
        }
        if (isChange) {
            this.callListener('tokenList');
        }
    }
    setTokenDecimals(key, decimals) {
        if (!key) {
            return;
        }
        let isChange = false;
        const tokenIndex = this.getTokenIndex(key);
        if (tokenIndex > -1) {
            const token = this.tokenList[tokenIndex];
            const newDecimals = new bifrost_number_1.default(decimals || token.decimals);
            if (!token.decimals.eq(newDecimals)) {
                isChange = true;
            }
            token.decimals = newDecimals;
        }
        else {
            this.tokenList.push(Object.assign({}, this.getDefaultToken(key), {
                decimals: new bifrost_number_1.default(decimals)
            }));
            isChange = true;
        }
        if (isChange) {
            this.callListener('tokenList');
        }
    }
    setTokenAddress(key, address) {
        if (!key) {
            return;
        }
        let isChange = false;
        const tokenIndex = this.getTokenIndex(key);
        if (tokenIndex > -1) {
            const token = this.tokenList[tokenIndex];
            if (token.address !== address) {
                isChange = true;
            }
            token.address = address;
        }
        else {
            this.tokenList.push(Object.assign({}, this.getDefaultToken(key), {
                address: address
            }));
            isChange = true;
        }
        if (isChange) {
            this.callListener('tokenList');
        }
    }
}
exports.default = BifiTokenList;
;
//# sourceMappingURL=BifiTokenList.js.map